import React, { useState, useEffect } from "react";
import { Box, VStack, Text } from "@chakra-ui/react";

const TableOfContents = ({ ace }) => {
    const [toc, setToc] = useState([]);

    useEffect(() => {
        if (!ace.current || !ace.current.editor) return;

        const editor = ace.current.editor;

        const generateToc = () => {
            const doc = editor.session.getDocument();
            const lines = doc.getAllLines();
            const newToc = [];

            const sectionRegex = /\\(part|chapter|section|subsection|subsubsection|paragraph|subparagraph)\*?\{(.*?)\}/;

            lines.forEach((line, index) => {
                const match = line.match(sectionRegex);
                if (match) {
                    newToc.push({
                        level: match[1],
                        title: match[2],
                        lineNumber: index + 1,
                    });
                }
            });
            setToc(newToc);
        };

        generateToc();

        let timeoutId;
        const onChange = () => {
            clearTimeout(timeoutId);
            timeoutId = setTimeout(generateToc, 1000);
        };

        editor.on("change", onChange);

        return () => {
            editor.off("change", onChange);
            clearTimeout(timeoutId);
        };
    }, [ace]);

    const jumpToLine = (lineNumber) => {
        if (ace.current && ace.current.editor) {
            ace.current.editor.gotoLine(lineNumber, 0, true);
            ace.current.editor.scrollToLine(lineNumber - 1, true, true, function () { });
            ace.current.editor.focus();
        }
    };

    const getIndentation = (level) => {
        switch (level) {
            case 'part': return 0;
            case 'chapter': return 1;
            case 'section': return 3;
            case 'subsection': return 6;
            case 'subsubsection': return 9;
            case 'paragraph': return 10;
            case 'subparagraph': return 12;
            default: return 2;
        }
    };

    return (
        <Box w="100%" h="100%" overflowY="auto" bg="#252526" color="#cccccc" p={2}>
            <VStack align="start" spacing={1}>
                {toc.length === 0 && (
                    <Box textAlign="center" py={4} w="100%">
                        <Text fontSize="sm" color="gray.500">No sections found.</Text>
                    </Box>
                )}
                {toc.map((item, idx) => (
                    <Box
                        key={idx}
                        pl={getIndentation(item.level)}
                        cursor="pointer"
                        _hover={{ color: "white", bg: "#37373d" }}
                        w="100%"
                        py={1}
                        borderRadius="sm"
                        onClick={() => jumpToLine(item.lineNumber)}
                        title={item.title}
                        transition="background 0.2s"
                    >
                        <Text fontSize="sm" whiteSpace="nowrap" overflow="hidden" textOverflow="ellipsis">
                            {item.title}
                        </Text>
                    </Box>
                ))}
            </VStack>
        </Box>
    );
};

export default TableOfContents;
